module.exports = __webpack_public_path__ + "fonts/Roboto-Black.ttf?5ebb24ee1112dd9562629375c387879a";